import {
  GET_USER_MAPPING,
  GET_USER_MAPPING_SUCCESS,
  GETTING_USER_MAPPING,
  SET_USER_MAPPING_PER_PAGE,
  SET_USER_MAPPING_SEARCH_KEYWORD,
  SET_ACTIVE_USER_MAPPING,
  OPEN_USER_MAPPING_DETAILS,
  CLOSE_USER_MAPPING_DETAILS,
  DELETE_USER_MAPPING,
  DELETING_USER_MAPPING,
  OPEN_DELETE_USER_MAPPING_MODAL,
  CLOSE_DELETE_USER_MAPPING_MODAL,
  UPDATE_USER_MAPPING,
  UPDATING_USER_MAPPING,
  OPEN_CREATE_USER_MAPPING_MODAL,
  CLOSE_CREATE_USER_MAPPING_MODAL,
  CREATE_USER_MAPPING,
  CREATING_USER_MAPPING,
  CREATING_USER_MAPPING_UPLOAD,
  OPEN_CREATE_USER_MAPPING_UPLOAD_MODAL,
  CLOSE_CREATE_USER_MAPPING_UPLOAD_MODAL,
  CREATE_USER_MAPPING_UPLOAD,
  CREATE_USER_MAPPING_UPLOAD_SELECTED_FILE,
} from 'state/actionTypes';

export const getUserMapping = payload => {
  return {
    type: GET_USER_MAPPING,
    payload,
  };
};

export const getUserMappingSuccess = payload => {
  return {
    type: GET_USER_MAPPING_SUCCESS,
    payload,
  };
};

export const setActiveUserMapping = payload => ({
  type: SET_ACTIVE_USER_MAPPING,
  payload,
});

export const gettingUserMappingAction = payload => {
  return {
    type: GETTING_USER_MAPPING,
    payload,
  };
};

export const setUserMappingPerPage = payload => {
  return {
    type: SET_USER_MAPPING_PER_PAGE,
    payload,
  };
};

export const setUserMappingSearchKeyword = payload => {
  return {
    type: SET_USER_MAPPING_SEARCH_KEYWORD,
    payload,
  };
};

export const openUserMappingDetails = () => ({
  type: OPEN_USER_MAPPING_DETAILS,
});

export const closeUserMappingDetails = () => ({
  type: CLOSE_USER_MAPPING_DETAILS,
});

export const deleteUserMapping = payload => {
  return {
    type: DELETE_USER_MAPPING,
    payload,
  };
};

export const deletingUserMappingAction = payload => {
  return {
    type: DELETING_USER_MAPPING,
    payload,
  };
};

export const openDeleteUserMappingModal = () => ({
  type: OPEN_DELETE_USER_MAPPING_MODAL,
});

export const closeDeleteUserMappingModal = () => ({
  type: CLOSE_DELETE_USER_MAPPING_MODAL,
});

export const updateUserMapping = payload => {
  return {
    type: UPDATE_USER_MAPPING,
    payload,
  };
};

export const updatingUserMappingAction = payload => {
  return {
    type: UPDATING_USER_MAPPING,
    payload,
  };
};

export const openCreateUserMappingModal = () => ({
  type: OPEN_CREATE_USER_MAPPING_MODAL,
});

export const closeCreateUserMappingModal = () => ({
  type: CLOSE_CREATE_USER_MAPPING_MODAL,
});

export const createUserMapping = payload => {
  return {
    type: CREATE_USER_MAPPING,
    payload,
  };
};

export const creatingUserMappingAction = payload => {
  return {
    type: CREATING_USER_MAPPING,
    payload,
  };
};

export const openCreateUserMappingUploadModal = () => ({
  type: OPEN_CREATE_USER_MAPPING_UPLOAD_MODAL,
});

export const closeCreateUserMappingUploadModal = () => ({
  type: CLOSE_CREATE_USER_MAPPING_UPLOAD_MODAL,
});

export const createUserMappingUpload = payload => {
  return {
    type: CREATE_USER_MAPPING_UPLOAD,
    payload,
  };
};

export const creatingUserMappingUploadAction = payload => {
  return {
    type: CREATING_USER_MAPPING_UPLOAD,
    payload,
  };
};

export const createUserMappingUploadSelectedFileAction = payload => {
  return {
    type: CREATE_USER_MAPPING_UPLOAD_SELECTED_FILE,
    payload,
  };
};
